export enum CollectJSFieldTypes {
    ccnumber = 'ccnumber',
    ccexp = 'ccexp',
    cvv = 'cvv'
}

export type CollectJSValidationType = CollectJSFieldTypes.ccnumber | CollectJSFieldTypes.ccexp | CollectJSFieldTypes.cvv | '';

export interface CollectJSValidationResult {
    type: CollectJSValidationType;
    valid: boolean;
    message: string;
}

export const initialCollectJSValidationResult: CollectJSValidationResult = {
    type: "",
    valid: true,
    message: ""
};
